export function loadScript(src) {
  return new Promise(function (resolve, reject) {
    if (document.querySelector(`script[src='${src}']`) === null) {
      const script = document.createElement('script')
      script.onload = function () {
        resolve()
      }
      script.onerror = function () {
        reject()
      }
      script.src = src

      document.querySelector('head').appendChild(script)
    } else {
      resolve()
    }
  })
}
